import { useState, useEffect, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { useCadaverService } from 'hooks/useCadaverService'

export const useExumarCadaver = (props) => {
  const { route, idCadaver } = props
  const router = useRouter()
  const cadaverService = useCadaverService()

  const [formValues, setFormValues] = useState({
    tipoExumacao: '',
    dataExumacao: new Date(),
    motivo: '',
    nomeSolicitante: '',
    tipoDocSolicitante: '',
    docSolicitante: '',
    orgaoExpedidorDocSolicitante: '',
  })

  const [formErrors, setFormErrors] = useState({})
  const [agentes, setAgentes] = useState([])
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [espelhoAberto, setEspelhoAberto] = useState(false)

  // Validação reativa dos campos obrigatórios
  useEffect(() => {
    const errors = {}
    if (!formValues.tipoExumacao) {
      errors.tipoExumacao = ['O tipo da exumação é obrigatório']
    }
    if (!formValues.dataExumacao) {
      errors.dataExumacao = ['A data da exumação é obrigatória']
    }
    if (!formValues.motivo || !formValues.motivo.trim()) {
      errors.motivo = ['O motivo da exumação é obrigatório']
    }
    if (!formValues.nomeSolicitante || !formValues.nomeSolicitante.trim()) {
      errors.nomeSolicitante = ['O nome do solicitante é obrigatório']
    }
    setFormErrors(errors)
  }, [
    formValues.tipoExumacao,
    formValues.dataExumacao,
    formValues.motivo,
    formValues.nomeSolicitante,
  ])

  const handleChangeCampo = useCallback((event) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }, [])

  const handleChangeWithModification = useCallback((event, modifier) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: modifier ? modifier(value) : value }))
  }, [])

  const handleChangeNewValueByNameProperty = useCallback((event, newValue, name) => {
    setFormValues((prev) => ({ ...prev, [name]: newValue }))
  }, [])

  const handleChangeCampoData = useCallback((name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }, [])

  const handleChangeAgentes = useCallback((value) => {
    if (value.length > 2) {
      return
    }
    setAgentes(value)
  }, [])

  const confirmarOperacao = useCallback(async (arquivos) => {
    const id_cadaver = route.origem === 'CADAVER' ? idCadaver : null

    const dados = {
      dataExumacao: formValues.dataExumacao || null,
      tipoExumacao: formValues.tipoExumacao || null,
      motivo: formValues.motivo || null,
      agentes,
      id_cadaver,
      arquivos,
      nomeSolicitante: formValues.nomeSolicitante || null,
      tipoDocSolicitante: formValues.tipoDocSolicitante || null,
      docSolicitante: formValues.docSolicitante || null,
      orgaoExpedidorDocSolicitante: formValues.orgaoExpedidorDocSolicitante || null,
    }

    await cadaverService.exumarCadaver(dados, setProcessandoOperacao)
    router.history.push(`/casos/caso/cadaver/detalhar/${idCadaver}`)
  }, [formValues, agentes, route.origem, idCadaver, router.history])

  const hasError = useCallback((name) => Boolean(formErrors[name]), [formErrors])

  return {
    formValues,
    formErrors,
    agentes,
    processandoOperacao,
    espelhoAberto,
    setEspelhoAberto,
    handleChangeCampo,
    handleChangeWithModification,
    handleChangeNewValueByNameProperty,
    handleChangeCampoData,
    handleChangeAgentes,
    confirmarOperacao,
    hasError,
    router,
  }
}
